import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';

export default function AddressModal({title, busy, onClose, children}) {
    const dialog = useRef(null);
    const close = useRef(onClose);
    const saving = useRef(busy);
    close.current = onClose;
    saving.current = busy;

    useEffect(() => {
        const trigger = document.activeElement;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const focusable = () => Array.from(dialog.current.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]'));
        dialog.current.querySelector('input:not(:disabled)')?.focus();
        const handleKey = event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                if (!saving.current) close.current();
            }
            if (event.key === 'Tab') {
                const elements = focusable();
                const first = elements[0];
                const last = elements[elements.length - 1];
                if (!first) {
                    event.preventDefault();
                    dialog.current.focus();
                } else if (event.shiftKey && (document.activeElement === first || !dialog.current.contains(document.activeElement))) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && (document.activeElement === last || !dialog.current.contains(document.activeElement))) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        document.addEventListener('keydown', handleKey);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleKey);
            if (trigger?.isConnected) trigger.focus();
        };
    }, []);

    return createPortal(
        <div className="nw-account nw-address nw-address-modal" onClick={event => {
            if (event.target === event.currentTarget && !busy) onClose();
        }}>
            <section ref={dialog} className="nw-address-modal__dialog ps-account-shell__card" role="dialog" aria-modal="true" aria-labelledby="address-editor-title" aria-describedby="address-editor-description" aria-busy={busy} tabIndex={-1}>
                <div className="nw-address-modal__header ps-account-shell__cardHeader">
                    <div>
                        <h2 id="address-editor-title">{title}</h2>
                        <p id="address-editor-description">Let us know where to deliver your order.</p>
                    </div>
                    <button type="button" className="nw-address-modal__close" aria-label="Close address form" disabled={busy} onClick={onClose}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>
                    </button>
                </div>
                <div className="nw-address-modal__body">{children}</div>
            </section>
        </div>, document.body
    );
}
